/* eslint-disable prefer-destructuring */
import assignments from '../../core/assignments';

export const operations = assignments.operations;
export const selectors = assignments.selectors;
export default assignments;
